export default "__VITE_ASSET__63605122__"